<template>
  <div>
    <UploadDocument />
  </div>
</template>

<script>
import UploadDocument from '../components/equipment/uploadDocument/uploadDocumentTable.vue'
export default {
  components: {
    UploadDocument,
  },
}
</script>

<style lang="scss" scoped></style>
